import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ec8b667"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-block" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "recipes" }

import RecipePanel from '../components/RecipePanel.vue';
import { useRoute } from 'vue-router'
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionView',
  setup(__props) {

const store = useStore()

const route = useRoute()
const slug = route.params.slug

const collection = computed(() => store.getters.getCollectionFromSlug(slug))
const recipeList = computed(() => store.getters.getCollectionRecipes(collection.value.id))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(collection).img,
          alt: ""
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_unref(collection).title), 1),
        _createElementVNode("h3", null, _toDisplayString(_unref(collection).subheading), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString(_unref(collection).desc), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipeList), (item) => {
        return (_openBlock(), _createBlock(RecipePanel, {
          key: item.slug,
          recipe: item
        }, null, 8, ["recipe"]))
      }), 128))
    ])
  ], 64))
}
}

})